import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { links } from '../collums-components/api/config';
import NotFoundView from './NotFoundView';
import LoadingView from './LoadingView';

const App = ({ children }) => {
    const [status, setStatus] = useState(null);

    useEffect(() => {
        // wait for the links to be pulled from the API;
        // 0 - not started, 1 - success, 2 - failed
        async function checkStatus() {
            if (links.status === 0) {
                // try again in a moment
                setTimeout(checkStatus, 100);
                return;
            }

            setStatus(links.status);
        }

        checkStatus();
    }, []);

    // whilst we have no status show a loading view, just a spinner in the
    // middle, which should disappear pretty quickly
    if (status === null) {
        return <LoadingView />;
    }

    // if the status is not 1 then show a not found view, this would indicate
    // the user hit a wildcard domain that does not link to an API.
    if (status !== 1) {
        return <NotFoundView clinicShortname={links.clinicShortname} />;
    }

    return <div>{children}</div>;
};

App.propTypes = {
    children: PropTypes.object.isRequired
};

export default App;
